import axios from 'axios';
import * as React from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import { Subscription, timer } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/fromPromise';
import { exhaustMap, map } from 'rxjs/internal/operators';
import Configuration from '../../api/configuration';
import BusStopService from '../../api/stadtbus/bus_stop_service';
import { encodeTripId } from '../../helpers';
import { lazyInject } from '../../inversify';
import ObserverComponent from '../observer_component';

interface IDbTblTripInfo {
  id: number;
  lineRef: string;
  journeyRef: string;
  operationDate: Date;
  direction: string;
  destinationText: string;
  originStopPoint: string;
  destinationStopPoint: string;
  startTimestamp: Date;
  endTimestamp: Date;
  line: string;
}

interface IDbTblTripInfoStopPoint {
  trip_id: number;
  id: string;
  name: string;
  sequenceNumber: string;
  arrivalTimestamp?: Date;
  departureTimestamp?: Date;
}

interface IDatabaseStop extends IDbTblTripInfoStopPoint {
  delay?: number;
  estimatedTime?: Date;
  shouldTime: Date;
  visited?: boolean;
}

interface IDatabaseTrip extends IDbTblTripInfo {
  endTimestampPredicted?: Date;
  operationDateString: string;
  startTimestampPredicted?: Date;
  stops: IDatabaseStop[];
  delay?: number;
  nextStopId?: string;
  tripId?: string;
  vehicleId?: string;
}

interface ITrip {
  delayMinutes: number;
  firstTimestamp: Date;
  lastTimestamp: Date;
  trip: IDatabaseTrip;
}

interface IVehicleInformation {
  vehicleId: string;
  trips: ITrip[];
}


interface IVehicleMappingDebugComponentState {
  vehicleInformation: IVehicleInformation[];
}

class VehicleMappingDebugComponent extends React.Component<{}, IVehicleMappingDebugComponentState> {
  @lazyInject(Configuration)
  private configuration: Configuration;
  @lazyInject(BusStopService)
  private busStopService: BusStopService;

  private apiSubscription: Subscription;

  constructor(props: {}) {
    super(props);

    this.state = {
      vehicleInformation: [],
    };
  }

  public componentDidMount() {
    this.apiSubscription = timer(0, 10000)
      .pipe(
        exhaustMap(() => fromPromise(axios
          .get(`${this.configuration.apiBaseUrl()}/vehiclemapping`)
          .then(result => result.data as IVehicleInformation[])
          .catch(() => [] as IVehicleInformation[]))),
      ).subscribe(vehicleInformation => this.setState({vehicleInformation}));
  }

  public componentWillUnmount() {
    this.apiSubscription.unsubscribe();
  }

  public render() {
    const vehicleInformation = this.state.vehicleInformation
      .sort((a, b) => a.vehicleId.localeCompare(b.vehicleId))
      .map(v => {
        const trips = v.trips.map(t => {

          const destinationText: any[] = [];

          if (t.trip.journeyRef !== undefined && t.trip.operationDate !== undefined) {
            destinationText.push(
              <Link key={t.trip.journeyRef}
                    to={`${process.env.PUBLIC_URL}/stadtbus/linie/${encodeTripId(t.trip.journeyRef, t.trip.operationDateString)}`}>{t.trip.line} {t.trip.destinationText}</Link>);
          } else {
            destinationText.push(`${t.trip.line} ${t.trip.destinationText}`);
          }

          const additionalText: any[] = [];

          if (t.trip.delay) {
            additionalText.push(`Delay: ${t.trip.delay}`);
          }

          if (t.trip.nextStopId) {
            const busStop = this.busStopService.onBusStop(t.trip.nextStopId).pipe(map(s => `Next Stop: ${s.name}`));
            additionalText.push(<ObserverComponent key={`${t.trip.nextStopId}`}>{busStop}</ObserverComponent>);
          }

          if (additionalText.length > 0) {
            destinationText.push(' [');

            additionalText.forEach((val, idx, arr) => {
              destinationText.push(val);
              if (idx !== arr.length - 1) {
                destinationText.push(', ');
              }
            });

            destinationText.push(']');
          }

          return <li key={t.trip.tripId}>
            {destinationText} (From <Moment date={t.firstTimestamp} format={'DD.MM.YYYY HH:mm:ss'}/> to <Moment
            date={t.lastTimestamp} format={'DD.MM.YYYY HH:mm:ss'}/>)
          </li>;
        });

        return <li key={v.vehicleId}>
          Vehicle ID: {v.vehicleId}
          <ul>
            {trips}
          </ul>
        </li>;
      });

    return (
      <div>
        <ul>
          {vehicleInformation}
        </ul>
      </div>
    );
  }
}

export default VehicleMappingDebugComponent;



// WEBPACK FOOTER //
// ./src/components/debug/vehicle_mapping_debug_component.tsx